import { entities } from '@/mocks/home';
import Reveal from '@/components/base/Reveal';

const STATE_STYLE: Record<string, string> = {
  未确认: 'bg-accent-100 text-accent-800',
  已回应: 'bg-secondary-100 text-secondary-800',
  已处置: 'bg-secondary-100 text-secondary-800',
  有争议: 'bg-primary-100 text-primary-700',
  待核实: 'bg-accent-100 text-accent-800',
  观点方: 'bg-background-200 text-foreground-700',
  跟进中: 'bg-background-200 text-foreground-700',
  活跃中: 'bg-primary-100 text-primary-700',
};

export default function Entities() {
  return (
    <section id="entities" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <Reveal>
          <div className="max-w-2xl">
            <span className="text-xs font-bold tracking-[0.3em] text-primary-600 md:text-sm">ENTITIES</span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              涉事主体 · 各方位置梳理
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              只以公开身份与公开动作为线索，标明每一方在当前事件中的位置，不涉及任何未公开的个人信息。
            </p>
          </div>
        </Reveal>

        <div className="mt-10 overflow-hidden rounded-lg border border-background-200 md:mt-12">
          <div className="hidden grid-cols-[1.1fr_2fr_auto] gap-6 bg-background-100 px-6 py-4 text-xs font-bold tracking-wide text-foreground-600 md:grid">
            <span>身份 / 角色</span>
            <span>当前公开动作</span>
            <span>状态</span>
          </div>
          <ul className="divide-y divide-background-200">
            {entities.map((item, index) => (
              <li key={item.role}>
                <Reveal delay={index * 35}>
                  <div className="grid grid-cols-1 gap-3 px-5 py-5 transition-colors hover:bg-background-100/60 md:grid-cols-[1.1fr_2fr_auto] md:items-center md:gap-6 md:px-6">
                    <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                      {item.role}
                    </h3>
                    <p className="text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                    <span
                      className={`w-fit rounded-full px-3 py-1 text-[11px] font-bold ${
                        STATE_STYLE[item.state] || 'bg-background-200 text-foreground-700'
                      }`}
                    >
                      {item.state}
                    </span>
                  </div>
                </Reveal>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}